import { showLoading } from "./helperFunctions";
import * as geoServerServices from "./Services/GeoServerServices";

const statistikModal = document.getElementById("statistikModal");
const modalHeaderStatistik = document.getElementById("modal-header-statistik");
const statistikCloseButton = document.getElementById("statistikCloseButton");

let statistikDaten = null;
const statistikAnzeigenButton = document.getElementById("statistikButton");
const statistikAlleButton = document.getElementById("statistikAlleButton");
const statistikGefaellteButton = document.getElementById(
  "statistikGefaellteButton"
);

const statistikStartDatum = document.getElementById("statistikStartDatum");
const statistikEndDatum = document.getElementById("statistikEndDatum");
const statistikAuswahlMenue = document.getElementById("statistikAuswahlMenue");
const zeigeStatistikAnButton = document.getElementById(
  "zeigeStatistikAnButton"
);

const statistikChart = document.getElementById("statistikChart");

let gefaellteBaeume = false;

export function setStatistikDaten(_statistikDaten) {
  statistikDaten = _statistikDaten;
}

statistikAnzeigenButton.addEventListener("click", async function () {
  await ladeStatistikDaten();
  statistikModal.style.display = "block";
  modalHeaderStatistik.style.display = "block";
  document.querySelectorAll(".statisticHeader").forEach(el => el.innerHTML = "Statistik zur Baumsuche");
});

statistikAlleButton.addEventListener("click", async function () {
  gefaellteBaeume = false;
  initialisiereStatistik();
});

statistikGefaellteButton.addEventListener("click", async function () {
  gefaellteBaeume = true;
  initialisiereStatistik();
});

zeigeStatistikAnButton.addEventListener("click", async function () {
  await ladeStatistikDaten();
});

statistikCloseButton.addEventListener("click", function () {
  schliesseStatistik();
});

function schliesseStatistik() {
  statistikModal.style.display = "none";
}

statistikStartDatum.addEventListener("change", function () {
  pruefeStartdatum();
});

statistikEndDatum.addEventListener("change", function () {
  pruefeEnddatum();
});

function initialisiereStatistik() {
  Chart.getChart(statistikChart)?.destroy();
  statistikModal.style.display = "block";
  modalHeaderStatistik.style.display = "block";

  statistikAuswahlMenue.options[0].selected = true;
  statistikStartDatum.options[0].selected = true;
  statistikEndDatum.options[
    statistikEndDatum.options.length - 1
  ].selected = true;

  pruefeStartdatum();
  pruefeEnddatum();

  if (gefaellteBaeume) {
    document.querySelectorAll(".statisticHeader").forEach(el => el.innerHTML = "Statistik zu gefällten Bäumen");
  } else {
    document.querySelectorAll(".statisticHeader").forEach(el => el.innerHTML = "Statistik zu allen Bäumen");
  }
}

function pruefeStartdatum() {
  zeigeStatistikAnButton.disabled = true;
  if (statistikStartDatum.value <= statistikEndDatum.value) {
    zeigeStatistikAnButton.disabled = false;
  }
}

function pruefeEnddatum() {
  zeigeStatistikAnButton.disabled = true;
  if (statistikEndDatum.value >= statistikStartDatum.value) {
    zeigeStatistikAnButton.disabled = false;
  }
}

async function ladeStatistikDaten() {
  showLoading(true);
  const jahresListe = erzeugeJahresListe(
    statistikStartDatum.value,
    statistikEndDatum.value
  );

  let statistikdaten = [];

  let daten;
  if (gefaellteBaeume) {
    daten = await geoServerServices.fetchDeletedTreesStatistics(
      statistikAuswahlMenue.value
    );

    statistikdaten.push({
      jahr: "2023",
      daten: daten,
    });
  } else {
    for (let jahr of jahresListe) {
      daten = await geoServerServices.fetchTreesStatistics(
        jahr,
        statistikAuswahlMenue.value
      );

      statistikdaten.push({
        jahr: jahr,
        daten: daten,
      });
    }
  }

  setStatistikDaten(statistikdaten);
  zeigeStatistikAn();
  showLoading(false);
}

function erzeugeJahresListe(startJahr, endJahr) {
  let jahresListe = [];
  for (let jahr = startJahr; jahr <= endJahr; jahr++) {
    jahresListe.push(jahr.toString());
  }
  return jahresListe;
}

function zeigeStatistikAn() {
  if (statistikDaten) {
    const daten = erstelleStatistik(
      statistikDaten,
      statistikAuswahlMenue.value
    );

    // Destroy the existing chart if it exists
    Chart.getChart(statistikChart)?.destroy();

    setzeStatistikHoehe(daten);
    erstelleChart(statistikChart, daten);
  }
}

function erstelleStatistik(statistikDaten, eigenschaft) {
  var jahresStatistik = {};

  // Iteriere über jedes Jahr und dessen Daten
  for (let jahrDaten of statistikDaten) {
    let jahr = jahrDaten.jahr;
    let daten = Array.isArray(jahrDaten.daten) ? jahrDaten.daten : [];

    // Initialisiere das Zählungs-Objekt für das aktuelle Jahr
    jahresStatistik[jahr] = {};

    // Überprüfe jedes Objekt in den Daten
    for (let baum of daten) {
      // Überprüfe, ob die Eigenschaft im aktuellen Objekt existiert
      if (
        baum.properties.hasOwnProperty(eigenschaft) &&
        baum.properties[eigenschaft] !== ""
      ) {
        // Hol dir den Wert der Eigenschaft
        let eigenschaftWert = baum.properties[eigenschaft];

        // Überprüfe, ob der Wert bereits im Zählungen-Objekt für das Jahr existiert
        if (jahresStatistik[jahr][eigenschaftWert]) {
          // Falls ja, erhöhe den Zähler
          jahresStatistik[jahr][eigenschaftWert]++;
        } else {
          // Falls nein, setze den Zähler auf 1
          jahresStatistik[jahr][eigenschaftWert] = 1;
        }
      }
    }

    // Sortiere die Statistik für das Jahr absteigend nach den Zählungen
    jahresStatistik[jahr] = Object.fromEntries(
      Object.entries(jahresStatistik[jahr]).sort(([, a], [, b]) => b - a)
    );
  }

  // Rückgabe des Zählungs-Objekts für alle Jahre
  return jahresStatistik;
}

function erstelleChart(statistikChart, daten) {
  Chart.register(ChartDataLabels);

  // Baumarten (Eigenschaften) und Jahre vorbereiten
  let jahre = Object.keys(daten);
  let eigenschaften = new Set();

  // Alle Eigenschaften (Baumarten) sammeln
  jahre.forEach((jahr) => {
    Object.keys(daten[jahr]).forEach((eigenschaft) =>
      eigenschaften.add(eigenschaft)
    );
  });

  eigenschaften = Array.from(eigenschaften);

  // Dataset vorbereiten
  let datasets = jahre.map((jahr) => {
    return {
      label: jahr,
      data: eigenschaften.map((eigenschaft) => daten[jahr][eigenschaft] || 0),
      backgroundColor: randomColor(), // Zufällige Farbe für jedes Jahr
      barThickness: 20, // Maximale Dicke der Balken, optional anpassen
      minBarLength: 40, // Minimale Länge der Balken, optional anpassen
    };
  });

  new Chart(statistikChart, {
    type: "bar",
    data: {
      labels: eigenschaften, // Baumarten auf der y-Achse setzen
      datasets: datasets, // Jahresdaten in separaten Datasets
    },
    options: {
      maintainAspectRatio: false,
      indexAxis: "y",
      scales: {
        x: {
          stacked: true,
          beginAtZero: true,
          grid: {
            display: false,
          },
          ticks: {
            font: {
              size: 14,
            },
          },
        },
        y: {
          stacked: true,
          grid: {
            display: false,
          },
          ticks: {
            font: {
              size: 18,
            },
            maxTicksLimit: eigenschaften.length,
          },
        },
      },
      plugins: {
        legend: {
          display: true,
        },
        datalabels: {
          anchor: "end",
          align: "start",
          font: {
            weight: "bold",
            size: 14,
            color: "#fff",
          },
          formatter: function (value) {
            return value;
          },
        },
      },
      layout: {
        padding: {
          left: 10,
          right: 10,
        },
      },
      responsive: true,
      aspectRatio: 1.5,
      barPercentage: 1.0, // Steuert die Breite der Balken im Verhältnis zur Kategorie
      categoryPercentage: 1.0, // Steuert die Breite der Balken innerhalb der Kategorie
    },
  });
}

// Hilfsfunktion für zufällige Farben in Blautönen
function randomColor() {
  const r = 0;
  const g = Math.floor(Math.random() * 128 + 127); // Helle Blau- oder Grün-Töne
  const b = Math.floor(Math.random() * 255);
  return `rgba(${r}, ${g}, ${b}, 0.7)`;
}

function setzeStatistikHoehe(daten) {
  let datensaetze = Object.values(daten);
  const anzahlDaten = Object.keys(datensaetze[0]).length;
  const hoeheProBar = 30;
  let hoeheStatistikBox = 450;

  if (anzahlDaten * hoeheProBar > hoeheStatistikBox) {
    hoeheStatistikBox = anzahlDaten * hoeheProBar;
  }
  const statistikBox = document.getElementById("statistikBox");
  statistikBox.style.height = hoeheStatistikBox + "px";
}
